import * as React from "react"
import styles from "./ToolbarPlugin.module.scss"

export const Divider = () => <div className={styles.divider} />
